export default "__VITE_ASSET__SrR2VHEP__"